module.exports = __webpack_public_path__ + "img/bf1_career.ba598788.jpg";